import React from 'react';
import GenericPullConfigListing from '../GenericPullConfigListing';
import SeekerMappingForm from './SeekerMappingForm';
import SeekerCredentialsForm from './SeekerCredentialsForm';

const SeekerConfigListing = (props) => (
    <GenericPullConfigListing
        {...props}
        toolName={props.name}
        MappingForm={SeekerMappingForm}
        CredentialsForm={SeekerCredentialsForm}
        componentName="Project"
        componentKey="projectName"
     />
);

export default SeekerConfigListing;
